<template>
  <div name="hrms41e-item" class="evaluation-item clearfix">
    <div class="col-xs-12 subject">
      {{ item.numitem }} {{ item.desc_numitem }} 
    </div>
    <div class="col-xs-12 clear-padding">
      <div class="special">
        {{ item.definit }} 
      </div>
      <div v-for="choice in choices" class="choice">
        <div class="col-xs-12 clear-padding radio">
          <div class="col-xs-2 col-md-1 clear-padding">
            <input type="radio" :value="choice.grditem" :id="name + '-' + dataGroup.numgrup + '-' + item.numitem + '-' + choice.grditem" v-model="item.grditem" />
            <label :for="name + '-' + dataGroup.numgrup + '-' + item.numitem + '-' + choice.grditem" class="radio-label"></label>
          </div>
          <item-desc :dataGroup="dataGroup" 
                     :item="item"
                     :choice="choice" />
        </div>
      </div>
      <form class="form-horizontal">
        <div class="form-group margin-b-5">
          <label class="col-md-12">{{ labels['HRMS41EC2']['140'] }}</label>
          <div class="col-md-12">
            <textarea  class="form-control" v-model="item.descomment" maxlength="500"></textarea> 
            <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div> 
          </div>
        </div>
      </form>
    </div>
    <div class="col-xs-12 clear-padding ">
      <div class="col-xs-12 clear-padding">
        <div class="weight-box clearfix">
          <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-star"></i> Weight : {{ item.qtywgt }}</div>
          <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-list-ul"></i> Score : {{ calQtyScore(item, choices) }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import itemDesc from 'components/hrms41e/itemDesc'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hrms41e-item',
  props: {
    dataGroup: {
      type: Object
    },
    item: {
      type: Object,
      required: true
    },
    choices: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    labels: {
      type: Object
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    calQtyScore (item, choices) {
      let choiceFiltered = choices.filter((choice) => {
        return choice.grditem === item.grditem
      })
      let qtyscor = 0
      let grad = ''
      if (choiceFiltered.length > 0) {
        qtyscor = parseFloat(choiceFiltered[0].qtyscor)
        grad = choiceFiltered[0].grad
      }
      this.$set(item, 'qtyscor', qtyscor * parseFloat(item.qtywgt))
      this.$set(item, 'grad', grad)
      return qtyscor
    }
  },
  components: {
    itemDesc
  }
}
</script>


// WEBPACK FOOTER //
// item.vue?4f52170b